export function getInfoArray(data) {
    if (Array.isArray(data))
        return data;
    return data ? [data] : undefined;
}
